import { useState, useEffect } from 'react';
import Page from '../components/Page';
import image from '../static/images/disclaimer.jpg';


const Disclaimer = (props) => {



  const [innerContent, setInnerContent] = useState('');
  const [innerContentEN, setInnerContentEN] = useState('');




  useEffect(() => {
    fetch('./content/disclaimer-NL.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContent(html);
  });

    fetch('./content/disclaimer-EN.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContentEN(html);
  });
    },[]);

  const content = <div className="content"
    dangerouslySetInnerHTML={{__html: innerContent ? innerContent : ''}}></div>

  const contentEN = <div className="content"
  dangerouslySetInnerHTML={{__html: innerContentEN ? innerContentEN : ''}}></div>


  document.title = 'Disclaimer - De School Amsterdam';
  const headerTitle = 'Disclaimer';
  const description = 'Disclaimer Disclaimer Disclaimer Disclaimer Disclaimer Disclaimer';


  return <Page
          headerTitle={headerTitle}
          description={description}
          content={props.langNL ? content : contentEN}
          image={image}
          langNL={props.langNL}
          changeLang={props.changeLang}/>


};

export default Disclaimer;
